/* eslint-disable import/namespace */
import { ColorOrCustom, dynamicStyling, resolveColor } from 'styles';

interface DualRingLoaderProps {
  size?: number;
  color?: ColorOrCustom;
  className?: string;
}

export function DualRingLoader({ color = 'primary', size = 20, className }: DualRingLoaderProps) {
  return (
    <div
      {...dynamicStyling({
        size,
        borderColor: `${resolveColor(color)} transparent ${resolveColor(color)} transparent`,
        borderWidth: size * 0.15,

        className: ['inline-block animate-spin rounded-full shrink-0', className],
      })}
    />
  );
}
